import React from 'react';
import utils from 'utils';
import styled from 'styled-components/macro';
import { modalActionType } from 'utils/constants';
import PdfRenderer from 'components/Pdf/newPdf';
import actions from 'state/actions';
import { useDispatch, useSelector } from 'react-redux';
import { CommonButton } from 'components/Buttons';
import selectors from 'state/selectors';
import Modal from 'components/Modal';

const Section = styled.div`
  margin-bottom: 20px;
`;

const GlossaryPreview = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const modalProps = useSelector(selectors.modal.getModalProps);
  const modalVisibility = useSelector(selectors.modal.getVisibility);

  const { documentImage, description } = modalProps;

  const handleClose = () => {
    dispatch(actions.modal.openModal(modalActionType.documents.GLOSSARY, { manuals: modalProps?.manuals }));
  };

  return (
    <Modal onClose={() => handleClose()} open={modalVisibility}>
      <>
        <Modal.Header title={description} subtitle={t('preview_document')} />
        <Modal.Content>
          <Section>
            <PdfRenderer
              key={documentImage}
              base64={documentImage}
              placeholderTitle="PDF Preview"
              placeholderDescription="Click here to load the PDF preview"
              showTranslateButtons
            />
          </Section>
        </Modal.Content>
        <Modal.Footer withConfirmButton={false} withCloseButton={false}>
          <CommonButton id="close" scope="secondary" action={() => handleClose()} value={t('close')} />
        </Modal.Footer>
      </>
    </Modal>
  );
};

export default GlossaryPreview;
